import GlobalStyles from '@mui/material/GlobalStyles';

export const EditorGlobalStyles: React.FC = () => (
  <GlobalStyles
    styles={(theme) => ({
      '.mdxeditor-popup-container': {
        zIndex: theme.zIndex.modal,
      },

      '.lightThemeStyles': {
        fontFamily: theme.typography.fontFamily,
        '--accentBase': theme.palette.primary.light,
        '--accentBgSubtle': theme.palette.primary[50],
        '--accentBg': theme.palette.primary[100],
        '--accentBgHover': theme.palette.primary[200],
        '--accentBgActive': theme.palette.primary[300],
        '--accentLine': theme.palette.primary[400],
        '--accentBorder': theme.palette.primary[500],
        '--accentBorderHover': theme.palette.primary[600],
        '--accentSolid': theme.palette.primary.main,
        '--accentSolidHover': theme.palette.primary.dark,
        '--accentText': theme.palette.primary.main,
        '--accentTextContrast': theme.palette.primary.contrastText,

        '--baseBase': theme.palette.background.default,
        '--baseBgSubtle': theme.palette.background.paper,
        '--baseBg': theme.palette.background.quaternary,
        '--baseBgHover': theme.palette.action.hover,
        '--baseBgActive': theme.palette.action.selected,
        '--baseLine': theme.palette.divider,
        '--baseBorder': theme.palette.divider,
        '--baseBorderHover': theme.palette.text.disabled,
        '--baseSolid': theme.palette.text.secondary,
        '--baseSolidHover': theme.palette.text.primary,
        '--baseText': theme.palette.text.primary,
        '--baseTextContrast': theme.palette.text.primary,
        '--basePageBg': theme.palette.background.paper,

        '--admonitionTipBg': theme.palette.success.light,
        '--admonitionTipBorder': theme.palette.success.main,

        '--admonitionInfoBg': theme.palette.info.light,
        '--admonitionInfoBorder': theme.palette.info.main,

        '--admonitionCautionBg': theme.palette.warning.light,
        '--admonitionCautionBorder': theme.palette.warning.main,

        '--admonitionDangerBg': theme.palette.error.light,
        '--admonitionDangerBorder': theme.palette.error.main,

        '--admonitionNoteBg': theme.palette.grey[100],
        '--admonitionNoteBorder': theme.palette.grey[400],
      },

      '.darkThemeStyles': {
        fontFamily: theme.typography.fontFamily,
        '--accentBase': theme.palette.primary.dark,
        '--accentBgSubtle': theme.palette.primary[900],
        '--accentBg': theme.palette.primary[800],
        '--accentBgHover': theme.palette.primary[700],
        '--accentBgActive': theme.palette.primary[600],
        '--accentLine': theme.palette.primary[500],
        '--accentBorder': theme.palette.primary[400],
        '--accentBorderHover': theme.palette.primary[300],
        '--accentSolid': theme.palette.primary.main,
        '--accentSolidHover': theme.palette.primary.light,
        '--accentText': theme.palette.primary.contrastText,
        '--accentTextContrast': theme.palette.primary.contrastText,

        '--baseBase': theme.palette.background.primaryAlt,
        '--baseBgSubtle': theme.palette.background.paper,
        '--baseBg': theme.palette.background.paper,
        '--baseBgHover': theme.palette.action.hover,
        '--baseBgActive': theme.palette.action.selected,
        '--baseLine': theme.palette.divider,
        '--baseBorder': theme.palette.divider,
        '--baseBorderHover': theme.palette.text.disabled,
        '--baseSolid': theme.palette.text.secondary,
        '--baseSolidHover': theme.palette.text.primary,
        '--baseText': theme.palette.text.primary,
        '--baseTextContrast': theme.palette.text.primary,
        '--basePageBg': theme.palette.background.primaryAlt,

        '--admonitionTipBg': theme.palette.success.dark,
        '--admonitionTipBorder': theme.palette.success.main,

        '--admonitionInfoBg': theme.palette.info.dark,
        '--admonitionInfoBorder': theme.palette.info.main,

        '--admonitionCautionBg': theme.palette.warning.dark,
        '--admonitionCautionBorder': theme.palette.warning.main,

        '--admonitionDangerBg': theme.palette.error.dark,
        '--admonitionDangerBorder': theme.palette.error.main,

        '--admonitionNoteBg': theme.palette.grey[800],
        '--admonitionNoteBorder': theme.palette.grey[600],
      },
    })}
  />
);
